<script setup>
import { ref, watch } from "vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

import {ROUTES} from "@/app/router";

const route = useRoute();
const transitionName = ref("");

watch(
  () => route.path,
  (newPath, oldPath) => {
    if (oldPath === ROUTES.START && newPath === ROUTES.MORE_INFO) {
      transitionName.value = "slide";
    } else if (oldPath === ROUTES.MORE_INFO && newPath === ROUTES.START) {
      transitionName.value = "slide-reverse";
    }
    else {
      transitionName.value = "";
    }
  }
);

const backgroundStyle = computed(() => ({
  "background-image": `url(${route.meta.backgroundImage})`,
}));
</script>

<template>
  <div class="solid-color">
    <div class="background" :style="backgroundStyle" />
  </div>
  <div class="scrolling-container">
    <transition :name="transitionName">
      <router-view :key="route.path" />
    </transition>
  </div>
</template>

<style>
html,
body {
  height: 100%;
  overflow: hidden;
}

.scrolling-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior-y: contain;

  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: env(safe-area-inset-bottom, 0px);

  z-index: 1;
}

.scrolling-container:has(.slide-enter-active, .slide-leave-active, .slide-reverse-enter-active, .slide-reverse-leave-active) {
  overflow: hidden;
}

.solid-color {
  background-color: var(--page-bg);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -2;
}

.background {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  overflow: auto;
  opacity: 0.2;
  z-index: -1;
}

.slide-enter-active,
.slide-leave-active {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: transform;
  transition: transform 1.5s ease;
}

.slide-enter-active {
  z-index: 2;
}

.slide-leave-active {
  z-index: 1;
}

.slide-enter-from {
  transform: translateY(100%);
}

.slide-enter-to {
  transform: translateY(0);
}

.slide-leave-from {
  transform: translateY(0);
}

.slide-leave-to {
  transform: translateY(-100%);
}

.slide-reverse-enter-active,
.slide-reverse-leave-active {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: transform;
  transition: transform 1.5s ease;
}

.slide-reverse-enter-active {
  z-index: 1;
}

.slide-reverse-leave-active {
  z-index: 2;
}

.slide-reverse-enter-from {
  transform: translateY(-100%);
}

.slide-reverse-enter-to {
  transform: translateY(0);
}

.slide-reverse-leave-from {
  transform: translateY(0);
}

.slide-reverse-leave-to {
  transform: translateY(100%);
}
</style>
